module.exports = __webpack_public_path__ + "static/media/empty-updates.498dbc5d.svg";